var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var DefaultAvatarO = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 124 124", width: "1em", height: "1em" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#7189B6", d: "M0 0h124v124H0z" }),
        React.createElement("g", { transform: "translate(30 24)", stroke: "#FFF", strokeWidth: 4 },
            React.createElement("circle", { cx: 32, cy: 16, r: 16 }),
            React.createElement("path", { d: "M64 76c0-17.673-14.327-32-32-32C14.327 44 0 58.327 0 76", strokeLinecap: "round" }))))); };
export default DefaultAvatarO;
//# sourceMappingURL=DefaultAvatarO.js.map